// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-F":"F_cost-saving-F__3_mKf"};